/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserJobTitleQueryVariables = GraphQL.Exact<{
  legacyUserId: GraphQL.Scalars['ID']['input'];
}>;


export type UserJobTitleQuery = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly jobTitle: string | null, readonly legacyId: string } | null };


export const UserJobTitleDocument = gql`
    query UserJobTitle($legacyUserId: ID!) {
  user(legacyId: $legacyUserId) {
    id
    jobTitle
    legacyId
  }
}
    `;

/**
 * __useUserJobTitleQuery__
 *
 * To run a query within a React component, call `useUserJobTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserJobTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserJobTitleQuery({
 *   variables: {
 *      legacyUserId: // value for 'legacyUserId'
 *   },
 * });
 */
export function useUserJobTitleQuery(baseOptions: Apollo.QueryHookOptions<UserJobTitleQuery, UserJobTitleQueryVariables> & ({ variables: UserJobTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserJobTitleQuery, UserJobTitleQueryVariables>(UserJobTitleDocument, options);
      }
export function useUserJobTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserJobTitleQuery, UserJobTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserJobTitleQuery, UserJobTitleQueryVariables>(UserJobTitleDocument, options);
        }
export function useUserJobTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserJobTitleQuery, UserJobTitleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserJobTitleQuery, UserJobTitleQueryVariables>(UserJobTitleDocument, options);
        }
export type UserJobTitleQueryHookResult = ReturnType<typeof useUserJobTitleQuery>;
export type UserJobTitleLazyQueryHookResult = ReturnType<typeof useUserJobTitleLazyQuery>;
export type UserJobTitleSuspenseQueryHookResult = ReturnType<typeof useUserJobTitleSuspenseQuery>;
export type UserJobTitleQueryResult = Apollo.QueryResult<UserJobTitleQuery, UserJobTitleQueryVariables>;